import React, { useEffect, useState } from "react";
import "./Overtime.scss";
import { Button, Col, Row, Select, Space, Tabs, TabsProps, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { BASE_API_URL } from "../../utils/consts";
import { setClientOvertime } from "../../utils/redux/slices/overtimeSlice";
import Table, { ColumnsType } from "antd/es/table";
import { setLoader } from "../../utils/redux/slices/loaderSlice";
import { format } from "date-fns";
import {
  CloseOutlined,
  CheckOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { isAdmin } from "../../utils/permissions";
import { EllipsisOutlined } from "@ant-design/icons";
import { Dropdown, Menu } from "antd";
type Props = {};

interface DataType {
  key: string;
  name: string;
  age: number;
  address: string;
  tags: string[];
}

const Overtimes: React.FC<Props> = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [selectedOvertime, setSelectedOvertime] = useState<any>(undefined);
  const [selectedOvertimeYear, setSelectedOvertimeYear] = useState<any>("2025");
  const [overtime, setOvertime] = useState<any>(undefined);
  const user = localStorage.getItem("user") ?? undefined;
  const clientId = user && JSON.parse(user)?.clientId;
  const userDetails = user && JSON.parse(user);

  const clientOvertime = useSelector(
    (state: any) => state.overtime.clientOvertime
  );

  useEffect(() => {
    // if (selectedOvertime) {
    dispatch(setLoader(true));
    axios
      .get(
        `${BASE_API_URL}/${clientId}/overtimes?${
          selectedOvertime ? `overtimeType=["${selectedOvertime ?? ""}"]` : ""
        }&year=${selectedOvertimeYear}`
      )
      .then((res) => {
        setOvertime(res.data);
      })
      .catch((err) => console.error(err))
      .finally(() => dispatch(setLoader(false)));
    // }
  }, [selectedOvertime, selectedOvertimeYear, clientId, dispatch]);

  useEffect(() => {
    if (clientId) {
      axios.get(`${BASE_API_URL}/admin/${clientId}/overtimes`).then((res) => {
        dispatch(setClientOvertime(res.data));
      });
    }
  }, [clientId, dispatch]);

  // useEffect(() => {
  //     if (clientOvertime?.length > 0) {
  //         setSelectedOvertime(clientOvertime[0]._id);
  //     }
  // }, [clientOvertime])

  const onChangeOvertimeType = (value: string) => {
    setSelectedOvertime(value);
  };

  const onChange = (key: string) => {
    console.log(key);
  };

  const onChangeOvertimeYear = (value: string) => {
    setSelectedOvertimeYear(value);
  };

  const onSearch = (value: string) => {
    console.log("search:", value);
  };

  const onUpdateOvertime = (status: any, overtimeId: any) => {
    dispatch(setLoader(true));
    axios
      .put(`${BASE_API_URL}/${overtimeId}/overtime_update`, {
        status: status,
      })
      .then((res) => {
        axios
          .get(
            `${BASE_API_URL}/${clientId}/overtimes?${
              selectedOvertime
                ? `overtimeType=["${selectedOvertime ?? ""}"]`
                : ""
            }&year=${selectedOvertimeYear}`
          )
          .then((res) => {
            // dispatch(setClientOvertime(res.data));
            setOvertime(res?.data);
          });
      })
      .catch((err) => console.error(err))
      .finally(() => dispatch(setLoader(false)));
  };

  const onDeleteOvertime = (overtimeId: any) => {
    dispatch(setLoader(true));
    axios
      .delete(`${BASE_API_URL}/${overtimeId}/overtime_delete`)
      .then((res) => {
        axios
          .get(
            `${BASE_API_URL}/${clientId}/overtimes?${
              selectedOvertime
                ? `overtimeType=["${selectedOvertime ?? ""}"]`
                : ""
            }&year=${selectedOvertimeYear}`
          )
          .then((res) => {
            // dispatch(setClientOvertime(res.data));
            setOvertime(res?.data);
          });
      })
      .catch((err) => console.error(err))
      .finally(() => dispatch(setLoader(false)));
  };

  const columns: ColumnsType<DataType> = [
    {
      title: t("Name"),
      dataIndex: "username",
      key: "username",
    },
    {
      title: t("Date Start"),
      dataIndex: "from",
      key: "from",
      render: (value, row) => {
        return format(new Date(value), "d-MMM-yyyy");
      },
    },
    {
      title: t("Date End"),
      dataIndex: "to",
      key: "to",
      render: (value, row) => {
        return format(new Date(value), "d-MMM-yyyy");
      },
    },
    {
      title: t("Overtime Type"),
      dataIndex: "overtimeName",
      key: "overtimeName",
    },
    {
      title: t("Status"),
      dataIndex: "status",
      key: "status",
      render: (value, status) => {
        const color =
          value === "APPROVED"
            ? "green"
            : value === "PENDING"
            ? "orange"
            : "red";
        return (
          <>
            <Tag color={color} key={value}>
              {t(value)}
            </Tag>
          </>
        );
      },
    },
    {
      title: t("Action"),
      key: "action",
      //   render: (row, record: any) => {
      //     return (
      //       <>
      //         {isAdmin(userDetails?.roles) && (
      //           <Space size="middle">
      //             <Button
      //               onClick={() =>
      //                 onUpdateOvertime("APPROVED", record.overtimeId)
      //               }
      //             >
      //               <CheckOutlined />
      //             </Button>
      //             <Button
      //               onClick={() =>
      //                 onUpdateOvertime("REJECTED", record.overtimeId)
      //               }
      //             >
      //               <CloseOutlined />
      //             </Button>
      //             <Button onClick={() => onDeleteOvertime(record.overtimeId)}>
      //               <DeleteOutlined />
      //             </Button>
      //           </Space>
      //         )}
      //       </>
      //     );
      //   },
      render: (_, record: any) => {
        if (!isAdmin(userDetails?.roles)) return null;

        const menu = (
          <Menu>
            <Menu.Item
              key="approve"
              icon={<CheckOutlined />}
              onClick={() => onUpdateOvertime("APPROVED", record.overtimeId)}
            >
              {t("Approve")}
            </Menu.Item>
            <Menu.Item
              key="cancel"
              icon={<CloseOutlined />}
              onClick={() => onUpdateOvertime("REJECTED", record.overtimeId)}
            >
              {t("Cancel")}
            </Menu.Item>
            <Menu.Item
              key="delete"
              icon={<DeleteOutlined />}
              danger
              onClick={() => onDeleteOvertime(record.overtimeId)}
            >
              {t("Delete")}
            </Menu.Item>
          </Menu>
        );

        return (
          <Dropdown overlay={menu} trigger={["click"]}>
            <Button icon={<EllipsisOutlined />} />
          </Dropdown>
        );
      },
    },
  ];

  const tabItems: TabsProps["items"] = [
    {
      key: "1",
      label: t("List"),
      children: (
        <Row>
          <Col xs={24}>
            <Table columns={columns} dataSource={overtime} />
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <div className="mainContainer">
      <div className="globalFilters">
        <div className="filter">
          <label htmlFor="overtimeTypeDropdown" className="dropdownLabel">
            {t("Overtime Type")}
          </label>
          <Select
            id="overtimeTypeDropdown"
            style={{ minWidth: 200 }}
            showSearch
            placeholder={t("Select a overtime type")}
            optionFilterProp="label"
            onChange={onChangeOvertimeType}
            onSearch={onSearch}
            value={selectedOvertime}
            options={clientOvertime?.map((overtime: any) => ({
              value: overtime._id,
              label: overtime.overtimeName,
            }))}
          />
        </div>
        <div className="filter">
          <label htmlFor="overtimeTypeDropdown" className="dropdownLabel">
            {t("Year")}
          </label>
          <Select
            id="overtimeTypeDropdown"
            style={{ minWidth: 200 }}
            showSearch
            placeholder={t("Select a year")}
            optionFilterProp="label"
            onChange={onChangeOvertimeYear}
            // onSearch={onSearch}
            value={selectedOvertimeYear}
            options={[
              { value: "2025", label: "2025" },
              { value: "2024", label: "2024" },
              { value: "2023", label: "2023" },
            ]}
          />
        </div>
      </div>
      <Tabs defaultActiveKey="1" items={tabItems} onChange={onChange} />
    </div>
  );
};

export default Overtimes;
